<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="handleBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
        <p class="d-inline-flex">
          <a v-if="!isNew" class="btn btn-danger btn-icon btn btn mar-rt-10 delete" @click.prevent="handleDelete">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card" style="width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>ID</label>
                  <input type="number"
                    disabled
                    :placeholder="ID"
                    v-model="model.id"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.name')}}</label>
                  <input type="text"
                    name="name"
                    data-vv-as="name"
                    :placeholder="$t('settingTable.name')"
                    v-validate="modelValidate.name"
                    v-model="model.name"
                    class="form-control">
                  <small class="text-danger" v-if="errors.has('name')">
                    {{ getError('name') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>Departament ID</label>
                  <input type="number"
                    name="department_id"
                    data-vv-as="department_id"
                    placeholder="Departament ID"
                    v-model="model.department_id"
                    class="form-control">
                  <small class="text-danger" v-if="errors.has('department_id')">
                    {{ getError('department_id') }}
                  </small>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>POS ID</label>
                  <input type="text"
                    name="pos_id"
                    data-vv-as="pos_id"
                    placeholder="beverage/food/12312"
                    v-model="model.pos_id"
                    class="form-control">
                  <small class="text-danger" v-if="errors.has('pos_id')">
                    {{ getError('pos_id') }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" style="height:auto; width:100%; margin-top: 10px;">
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>Statusuri de lucru</h5>
                  <hr class="sm">
                  <table class="table mar-bt-0">
                    <thead>
                      <tr>
                        <th width="1%"></th>
                        <th width="9%">ID</th>
                        <th width="45%">{{$t('kds.name')}}</th>
                        <th width="45%">{{$t('kds.deliveryMethods')}}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <draggable v-model="model.statuses" :list="model.statuses" :options="{group:model.statuses}" :element="'tbody'">
                      <tr class="sortableRow draggable-highlight" v-for="(status, index) in model.statuses">
                        <td>
                          <i style="cursor: move; color: #674BD2;" class="fa fa-arrows sortHandle"></i>
                        </td>
                        <td>
                          <input type="text" placeholder="ID" disabled class="form-control" :name="'amount'+status.id" v-model="status.id">
                        </td>
                        <td>
                          <input type="text" :placeholder="'PROCESSING ' + (index + 1)" class="form-control" :name="'amount'+status.id" v-model="status.name" v-validate="{required: true}" >
                        </td>
                        <td>
                          <v-select
                            v-model="model.statuses[index].delivery_methods"
                            multiple
                            :options="deliveryMethods"
                            :placeholder="$t('general.all')">
                          </v-select>
                          <!-- <small class="text-danger" v-if="errors.has(status.hash_id)">
                            {{ getError(status.hash_id) }}
                          </small> -->
                        </td>
                        <td>
                          <button class="btn btn-danger btn-icon pull-right" @click.prevent="deleteStatus(status, index)"><i title="Remove" class="ti-trash "></i></button>
                        </td>
                      </tr>
                      <tr v-if="!model.statuses.length">
                        <td></td>
                        <td></td>
                        <td>
                          <h6 class="no-data">{{$t('kds.noData')}}</h6>
                        </td>
                        <td></td>
                      </tr>
                    </draggable>
                  </table>
                  <button
                    class="btn add mar-to-15"
                    @click.prevent="addNewStatus()"
                    :title="$t('general.add') + ' ' + $t('settingTaxes.single')">
                    <img src="/static/img/icons/add.png">
                    {{$t('general.add')}}
                  </button>
                </div>
                <div class="text-center">
                  <span class="help-block warning mb-0"><i class="fa fa-info-circle" aria-hidden="true"></i>Aceste statusuri sunt situate strict intre PROCESARE si PREPARAT</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import draggable from 'vuedraggable'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      draggable
    },
    data () {
      return {
        apiUrl: '',
        id: this.route.params.id || null,
        isNew: true,
        model: {
          'name': '',
          'statuses': []
        },
        modelValidate: {
          name: {required: true}
        },
        deliveryMethods: [],
        deleteStatuses: [],
        loading: true
      }
    },
    props: {
      callback: {
        required: false
      },
      route: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ID () {
        return this.route.params.id || null
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.deliveryMethods = this.getCompanyDetail('delivery_options_labels')
      this.getData()
    },
    methods: {
      getData () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if ((this.route.params.id !== undefined && this.route.params.id) ||
          (this.id !== undefined && this.id !== null)) {
          this.isNew = false
        } else {
          this.isNew = true
        }
        if (!this.isNew) {
          var id = this.route.params.id || this.id
          this.apiRequest('/sections/' + id, 'GET', data, (response) => {
            if (response.status === true) {
              this.model = response.data
              this.loading = false
            }
          })
        } else {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveKdsSection() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveKdsSection () {
        this.loading = true
        let data = this.model
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        var id = this.id || this.route.params.id

        if (id) {
          data.delete_statuses = this.deleteStatuses
          this.apiRequest('/sections/' + data.id, 'PUT', data, (response) => {
            if (response.status) {
              this.loading = false
              this.errors.clear()
              swal(
                {
                  title: '',
                  text: this.$t('general.success'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              .then(() => {})
              .catch(() => {})
              this.handleBack()
            } else {
              this.loading = false
              this.handleErrors(response.errors)
            }
          })
        } else {
          this.apiRequest('/sections/', 'POST', data, (response) => {
            if (response.status) {
              this.loading = false
              this.errors.clear()
              swal(
                {
                  title: '',
                  text: this.$t('general.success'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              .then(() => {})
              .catch(() => {})
              this.handleBack()
            } else {
              this.loading = false
              this.handleErrors(response.errors)
            }
          })
        }
      },
      handleDelete () {
        swal({
          title: this.$t('general.generalAreYouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            this.deleteKdsSection()
          }
        })
      },
      deleteKdsSection () {
        this.loading = true
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/sections/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            this.loading = false
            swal({
              title: this.$t('general.success'),
              type: 'success'
            })
            this.handleBack()
          } else {
            this.loading = false
            swal({
              title: this.$t('general.error'),
              type: 'error'
            })
          }
        })
      },
      handleBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push('/screens/kds?tabIndex=3')
      },
      addNewStatus () {
        let newRow = {
          'id': null,
          'company_id': this.$session.get('selectedCompany'),
          'location_id': this.model.location_id,
          'name': null,
          'delivery_methods': []
        }
        this.model.statuses.push(newRow)
      },
      deleteStatus (status, index) {
        if (status.id) {
          this.deleteStatuses.push(status)
        }
        this.model['statuses'].splice(index, 1)
      }
    }
  }
</script>
<style scopped>
  .no-data {
    display: flex;
    justify-content: end;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/Sections/KdsSectionForm.vue